import styled from 'styled-components';

export const Error = styled.div`
  margin-top: 5rem;
  display: flex;
  justify-content: center;
`;
